import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../layout/sidebar/Sidebar';
import Header from '../layout/header/Header';
import Footer from '../layout/footer/Footer';
import TextModal from '../common/Modals/TextModal';
import FullScreenModal from '../common/Modals/FullScreenModal';
import CustomModal from '../common/Modals/CustomModal';
import SmallCustomModal from '../common/Modals/SmallCustomModal';
import { closeModalAction, openCustomModal, openProgressBarModal, closeFullScreenModalAction } from '../actions/modal';
import { useDispatch } from 'react-redux';
import MediaView from '../common/MediaView';
import ProgressBarModal from '../common/Modals/ProgressBarModal';
import CallModal from '../common/Modals/CallModal';
import { detailsPath, trackSupportTicket } from './roleWisePageRoute';
import { isMobileView } from '../utils/utils';
import { TicketProgressBar } from '../pages/Ticket';
import MediumChatBox from '../pages/chat/MediumChatBox';
import NatsServiceAll from '../utils/nats';
import { GET_TICKET_PROGRESS } from '../types/service_request';
import { openChatModal } from '../actions/chat';
import { GET_CHAT_AND_SET_AT_FIRST, NEW_MESSAGE_CHAT_ID } from '../types/chat';
import UpdatRequiredFields from '../pages/UserProfile/UpdateRequiredFields';
import { hideIntalkWidget } from '../actions/intalk';
import IntalkGlobalWidget from '../components/IntalkLogin/IntalkGlobalWidget';
import { canPlaceOutboundCalls } from '../utils/access';
import { devLog } from '../utils/common';

const SidebarLayout = () => {
    const { isTextModalOpen, isCustomModalOpen, isSmallCustomModalOpen, isFullScreenModalOpen, isMediaViewModalOpen, isProgressBarModalOpen, isOnCall } = useSelector((state) => state.modal);
    const dispatch = useDispatch();
    const { downloadProgressList } = useSelector((state) => state.modal);
    const ticketProgress = useSelector((state) => state.serviceRequest.ticketProgress)
    const { pathname } = useLocation();
    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);
    const showReuiredPopups = ![trackSupportTicket.path, detailsPath.path].includes(pathname);
    const mainChatContanerRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (!newLoggedUserData?.user?.id) return;
        const topic = `task.${newLoggedUserData.user.id}.progress`;
        const cb = (chunk) => {
            const parse = JSON.parse(chunk);
            dispatch({ type: GET_TICKET_PROGRESS, payload: parse })
        }

        const subscribeToTopic = async () => {
            try {
                await NatsServiceAll.subscribe(topic, cb);
            } catch (error) {
                console.error('❌ Subscription failed:', error);
            }
        };

        subscribeToTopic();

        return () => {
            console.log('🔴 Unsubscribing from:', topic);
            NatsServiceAll.unsubscribe(topic);
        };
    }, [newLoggedUserData?.user?.id, dispatch]);

    useEffect(() => {
        localStorage.removeItem('IS_PLAYING');
        localStorage.removeItem('40_SEC_NO_PLAY');
    }, []);


    useLayoutEffect(() => {
        dispatch(closeModalAction());
        dispatch(closeFullScreenModalAction());
    }, [window.location.href, dispatch]);

    useEffect(() => {
        if (Array.isArray(downloadProgressList) && downloadProgressList.length > 0 && !isProgressBarModalOpen) {
            dispatch(openProgressBarModal());
        }
    }, [downloadProgressList, dispatch, isProgressBarModalOpen]);


    useEffect(() => {
        const topic = `chat.*.${newLoggedUserData.user.id}`;
        const cb = (chunk) => {
            const parse = JSON.parse(chunk)
            devLog('--------------SIDEBAR_LAYOUT-------------')
            devLog('--------------SIDEBAR_LAYOUT-------------')
            devLog('--------------SIDEBAR_LAYOUT-------------')
            devLog('chunk:', chunk)
            devLog('parse:', parse)
            devLog('newLoggedUserData.user.id:', newLoggedUserData.user.id)
            devLog('--------------SIDEBAR_LAYOUT-------------')
            devLog('--------------SIDEBAR_LAYOUT-------------')

            const isTaggedCurrentUser = parse?.data?.mentions?.find((mention) => mention.user_id === newLoggedUserData.user.id)

            const isSenderIsLoginUser = parse?.data?.author_id === newLoggedUserData.user.id || parse?.data?.author_name === newLoggedUserData.user.full_name;
            if (window.location.pathname.includes('/chat')) {
                dispatch({ type: NEW_MESSAGE_CHAT_ID, payload: { data: parse.data, isSenderIsLoginUser } })
                dispatch({ type: GET_CHAT_AND_SET_AT_FIRST, payload: { id: parse.data.chatId, navigate } })
            }

            if (isTaggedCurrentUser && !window.location.pathname.includes('/chat') && parse?.data?.type !== 'EVENT') {
                dispatch(openChatModal({ chatId: parse.data.chatId, openInBackground: true }));
            }

            if (parse.event === 'outbound.ended') {
                dispatch(hideIntalkWidget({
                    type: parse.event, data: {
                        user_id: parse.data.user_id,
                        ticket_id: parse.data.ticket_id
                    }
                }));
            }
        }

        const subscribeToTopic = async () => {
            try {
                await NatsServiceAll.subscribe(topic, cb);
            } catch (error) {
                console.error('❌ Subscription failed:', error);
            }
        };

        subscribeToTopic();

        return () => {
            console.log('🔴 Unsubscribing from:', topic);
            NatsServiceAll.unsubscribe(topic);
        };
    }, [newLoggedUserData?.user?.id, newLoggedUserData.user.full_name, dispatch, navigate]);


    useEffect(() => {
        const is_address_required = newLoggedUserData.user.roles.find((role) => role.is_address_required);
        if (is_address_required && !newLoggedUserData.user.address) {
            let heading = 'Update Required Details';
            let modalComponent = <UpdatRequiredFields />;
            let modalHeight = 'auto',
                modalWidth = '50rem';
            dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth, showLogout: true, showClose: false }));
        }
    }, [newLoggedUserData, dispatch]);

    return (
        <div className={`h-screen overflow-hidden ${showReuiredPopups ? 'bg-scogogray' : 'bg-ticketSideDawerColor'}`}>
            <Header isInactiveUser={!showReuiredPopups} isSupoortTicketPath={[trackSupportTicket.path].includes(pathname)} />
            <div className='flex bg-scogof8 md:overflow-auto lg:overflow-hidden'>
                <div>
                    {showReuiredPopups && <Sidebar mainChatContanerRef={mainChatContanerRef} />}
                </div>

                <div ref={mainChatContanerRef} className={showReuiredPopups ? isMobileView ? "mainContainerMobileView" : "mainContainer" : 'mainContainerForUnauthorisedUser'}>
                    <Outlet />
                </div>
            </div>
            {showReuiredPopups && <Footer />}
            {/* adding new modals here is not a good idea, think of storing in a variable */}
            {isTextModalOpen && <TextModal />}
            {isCustomModalOpen && <CustomModal />}
            {isFullScreenModalOpen && <FullScreenModal />}
            {isSmallCustomModalOpen && <SmallCustomModal />}
            {isMediaViewModalOpen && <MediaView />}
            {isProgressBarModalOpen && <ProgressBarModal />}
            {(ticketProgress?.payload?.processedRecords !== ticketProgress?.payload?.
                totalRecords) && <TicketProgressBar />}
            {isOnCall && <CallModal />}
            <MediumChatBox />
            {canPlaceOutboundCalls(newLoggedUserData.actions) && <IntalkGlobalWidget />}

        </div>
    );
};

export default SidebarLayout;
